import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SuperService {
	constructor(private http: HttpClient, private authService: AuthService) {}

	/**
	 * Create the login request for super users
	 * @param email super user email
	 * @param password super user password
	 * @returns Observable
	 */
	public signInSu(email: string, password: string): Observable<any> {
		const url = environment.backend.userURL + '/super/login/';

		const body = { email, password };

		return this.http.post<any>(url, body).pipe(
			map((user) => {
				if (
					user.AuthenticationResult &&
					user.AuthenticationResult.AccessToken
				) {
					localStorage.setItem('superUser', 'true');
					this.authService.setCredentials(
						user.AuthenticationResult.AccessToken,
						user.AuthenticationResult.IdToken,
						user.AuthenticationResult.RefreshToken
					);
				}
				return user;
			})
		);
	}

	/**
	 * Creates the requisition for user Access Token refresh
	 * @returns Observable
	 */
	public refreshToken(): Observable<any> {
		const url = environment.backend.userURL + '/super/refresh';

		const headers = {
			'access-token': this.authService.accessToken,
			'refresh-token': this.authService.refreshToken,
		};

		return this.http.get<any>(url, { headers });
	}

	/**
	 * Request the B2G users (administrative and operational users)
	 * @returns Observable
	 */
	public getB2GUsers(): Observable<any> {
		const url = environment.backend.userURL + '/super/users/b2g';

		return this.http.get<any>(url);
	}

	/**
	 * Create the request for admin registry
	 * @param data All the info about the admin
	 * @returns Observable
	 */
	public createAdmin(data): Observable<any> {
		const url = environment.backend.userURL + '/super/create-admin';

		return this.http.post<any>(url, data);
	}

	/**
	 * Create the request for delete an user (administrative or operational)
	 * @param data Object with necessary admin data
	 * @returns Observable http com a requisição
	 */
	public deleteAdmin(data): Observable<any> {
		const id = data.sub;
		const url = environment.backend.userURL + `/super/force-delete-user/${id}`;

		return this.http.delete<any>(url);
	}

	/**
	 * Create the request for edit an user (administrative or operational)
	 * @param data Objects to be changed
	 * @returns Observable
	 */
	public editAdmin(data): Observable<any> {
		const url = environment.backend.userURL + '/super/users/b2g';

		return this.http.put<any>(url, data);
	}
}
